import { useFloorMapPresenter } from '@Map/FloorMap/FloorMapPresenter';
import { observer } from 'mobx-react-lite';
import { StyleSheet, View } from 'react-native';

import { ElevatorArrowButton } from './Components/ElevatorArrowButton';
import { ElevatorTextButton } from './Components/ElevatorTextButton';
import { ARROW_BUTTON_HEIGHT, TEXT_BUTTON_HEIGHT } from './elevatorPanelSizes';

const SHOW_ELEVATOR_ARROWS = false;

export const ElevatorPanel = observer(function ElevatorPanel() {
  const {
    reversedFloorsVM,
    goFloor,
    goUp,
    goDown,
    upButtonEnabled,
    downButtonEnabled,
    selectedFloorId,
  } = useFloorMapPresenter();

  const maxHeight =
    ARROW_BUTTON_HEIGHT * 2 + TEXT_BUTTON_HEIGHT * reversedFloorsVM.length;

  return (
    <View style={[styles.wrapper, { maxHeight }]}>
      {SHOW_ELEVATOR_ARROWS && (
        <ElevatorArrowButton
          direction='up'
          disabled={!upButtonEnabled}
          onPress={goUp}
        />
      )}
      {reversedFloorsVM.map((floor) => (
        <ElevatorTextButton
          key={floor.id}
          onPress={() => {
            goFloor(floor.id);
          }}
          label={floor.title}
          isCurrent={selectedFloorId.value === floor.id}
        />
      ))}
      {SHOW_ELEVATOR_ARROWS && (
        <ElevatorArrowButton
          direction='down'
          disabled={!downButtonEnabled}
          onPress={goDown}
        />
      )}
    </View>
  );
});

const styles = StyleSheet.create({
  wrapper: {
    justifyContent: 'flex-end',
    width: '100%',
    height: '100%',
  },
});
